import getCurrentLocationUrl from 'common/src/modules/routing/utils/getCurrentLocationUrl';
import {randomKey} from 'common/src/utils/commonUtils';
import {ChatItemType} from '../../copilot.enums';
import {Article, AssistantChatItem, PlaintextPart, Resource} from '../../copilot.types';
import {CopilotWidget} from '../../bootstrap/bootstrap.types';

export default function assistantChatItem({
  agent,
  parts,
  articles = [],
  resources = [],
}: {
  agent: string;
  parts: (PlaintextPart | CopilotWidget)[];
  articles?: Article[];
  resources?: Resource[];
}): AssistantChatItem {
  return {
    type: ChatItemType.Assistant,
    id: randomKey(),
    parts,
    agent,
    articles,
    resources,
    uiLocation: getCurrentLocationUrl(),
  };
}
